<template>

    <span :class="theClass"
          v-if="customer">
      <div class="row">
        <div class="col-md-6">
            <b-form-checkbox
                v-if="customer.cardcode != 'ALLE'"
                :id="'checkbox-' + customer.id"
                v-model="isChecked"
                name="isChecked"
                @change="toggleChecked"
                value="true"
                unchecked-value="false">
                {{ label }}
            </b-form-checkbox>
            <div v-else>
              <!-- Status-Badge: aktueller Zustand -->
              <b-button size="sm"
                        class="notification-btn-status mr-2"
                        :variant="isChecked === true ? 'success' : (isChecked === false ? 'danger' : 'primary')"
                        v-b-tooltip.hover.top
                        :title="isChecked === true ? $t('message.customerNotifications_fuer_alle_desc') : (isChecked === false ? $t('message.customerNotifications_fuer_alle_inaktiv_desc') : $t('message.customerNotifications_fuer_andere_desc'))">
                <span class="notification-btn-status-icon">
                  <b-icon :icon="isChecked === true ? 'check-circle-fill' : (isChecked === false ? 'dash-circle-fill' : 'sliders')"></b-icon>
                </span>
                <span class="notification-btn-status-label">
                  {{ isChecked === true ? $t('message.customerNotifications_status_aktiviert') : (isChecked === false ? $t('message.customerNotifications_status_deaktiviert') : $t('message.customerNotifications_status_individuell')) }}
                </span>
              </b-button>
              <!-- Aktionen: nur Zustaende, zu denen gewechselt werden kann -->
              <b-button-group size="sm" class="notification-btn-actions" :id="'checkbox-' + customer.id">
                <b-button v-if="isChecked !== true"
                          variant="outline-success"
                          v-b-tooltip.hover.top
                          :title="$t('message.customerNotifications_fuer_alle_aktivieren')"
                          @click="setIsChecked(true)">
                  <b-icon icon="check-circle-fill"></b-icon>
                </b-button>
                <b-button v-if="isChecked !== false"
                          variant="outline-danger"
                          v-b-tooltip.hover.top
                          :title="$t('message.customerNotifications_fuer_alle_deaktivieren')"
                          @click="setIsChecked(false)">
                  <b-icon icon="dash-circle-fill"></b-icon>
                </b-button>
              </b-button-group>
              &nbsp;<label :for="'checkbox-' + customer.id">{{ label }}</label>
            </div>
        </div>
        <div class="col-md-6">
            <b-form-checkbox
                v-if="customer.cardcode != 'ALLE'"
                :id="'checkbox-app-' + customer.id"
                v-model="isCheckedApp"
                name="isCheckedApp"
                @change="toggleCheckedApp"
                value="true"
                unchecked-value="false">
                {{ labelApp }}
            </b-form-checkbox>
            <div v-else>
              <b-button size="sm"
                        class="notification-btn-status mr-2"
                        :variant="isCheckedApp === true ? 'success' : (isCheckedApp === false ? 'danger' : 'primary')"
                        v-b-tooltip.hover.top
                        :title="isCheckedApp === true ? $t('message.customerNotifications_fuer_alle_desc') : (isCheckedApp === false ? $t('message.customerNotifications_fuer_alle_inaktiv_desc') : $t('message.customerNotifications_fuer_andere_desc'))">
                <span class="notification-btn-status-icon">
                  <b-icon :icon="isCheckedApp === true ? 'check-circle-fill' : (isCheckedApp === false ? 'dash-circle-fill' : 'sliders')"></b-icon>
                </span>
                <span class="notification-btn-status-label">
                  {{ isCheckedApp === true ? $t('message.customerNotifications_status_aktiviert') : (isCheckedApp === false ? $t('message.customerNotifications_status_deaktiviert') : $t('message.customerNotifications_status_individuell')) }}
                </span>
              </b-button>
              <b-button-group size="sm" class="notification-btn-actions" :id="'checkbox-app-' + customer.id">
                <b-button v-if="isCheckedApp !== true"
                          variant="outline-success"
                          v-b-tooltip.hover.top
                          :title="$t('message.customerNotifications_fuer_alle_aktivieren')"
                          @click="setIsCheckedApp(true)">
                  <b-icon icon="check-circle-fill"></b-icon>
                </b-button>
                <b-button v-if="isCheckedApp !== false"
                          variant="outline-danger"
                          v-b-tooltip.hover.top
                          :title="$t('message.customerNotifications_fuer_alle_deaktivieren')"
                          @click="setIsCheckedApp(false)">
                  <b-icon icon="dash-circle-fill"></b-icon>
                </b-button>
              </b-button-group>
              &nbsp;<label :for="'checkbox-app-' + customer.id">{{ labelApp }}</label>
            </div>
        </div>
      </div>
    </span>

</template>

<script>

    import axios from 'axios'
    import bootbox from 'bootbox'
    axios.defaults.withCredentials = true

    export default {
      name: 'DisableNotificationNeuerBesuchsbericht',
      props: [
          /** customer kann auch ein Objekt mit ID 'ALLE' sein, um für alle Standorte des Keyusers Werte zu setzen */
          'customer',
          'label',
          'labelApp',
      ],
      data () {
        return {
          isChecked: null,
          isCheckedApp: null,
        }
      },
      watch: {

        customer: function () {
          this.init()
        },
        '$store.state.allEmailNotificationInactive': function () {
          console.log('allEmailNotificationInactive', this.$store.state.allEmailNotificationInactive)
          this.init()
        },
        '$store.state.allEmailNotificationActive': function () {
          console.log('allEmailNotificationActive', this.$store.state.allEmailNotificationActive)
          this.init()
        },
        '$store.state.allAppNotificationInactive': function () {
          console.log('allAppNotificationInactive', this.$store.state.allAppNotificationInactive)
          this.init()
        },
        '$store.state.allAppNotificationActive': function () {
          console.log('allAppNotificationActive', this.$store.state.allAppNotificationActive)
          this.init()
        }

      },
      computed: {

        theClass: function () {

          if (this.label) {
            return 'disableNotificationNeuerBesuchsberichtLabel'
          }
          return 'disableNotificationNeuerBesuchsbericht'

        }

      },
      created () {

        this.init()

      },
      methods: {

        toggleCheckedApp: function () {

          console.log('toggleCheckedApp', this.isCheckedApp)
          this.change(null, this.isCheckedApp)

        },
        toggleChecked: function () {

          console.log('toggleChecked', this.isChecked)
          this.change(this.isChecked, null)

        },
        setIsChecked: function (newVal) {

          console.log('setIsChecked newVal = ' + newVal + ' oldVal = ' + this.isChecked)
          if (newVal == null || newVal === this.isChecked) return
          this.confirmIfAlle(newVal, () => this.change(newVal, null))

        },
        setIsCheckedApp: function (newVal) {

          console.log('newVal = ' + newVal + ' oldVal = ' + this.isCheckedApp)
          if (newVal == null || newVal === this.isCheckedApp) return
          this.confirmIfAlle(newVal, () => this.change(null, newVal))

        },
        /**
         * Bei cardcode=ALLE zeigt einen Bestätigungsdialog, da die Einstellung
         * auf alle Standorte angewendet wird. Sonst direkt ausführen.
         */
        confirmIfAlle: function (newVal, onConfirm) {

          if (this.customer.cardcode === 'ALLE') {
            const key = newVal
                ? 'message.customerNotifications_fuer_alle_aktivieren_confirm'
                : 'message.customerNotifications_fuer_alle_deaktivieren_confirm'
            bootbox.confirm(this.$t(key), result => {
              if (result) onConfirm()
            })
          } else {
            onConfirm()
          }

        },
        change: function (newVal, newValApp) {

          console.log('isChecked geändert auf ' + newVal + ' ' + newValApp)

            this.showSpinner()
            // Ausnahme setzen:
            const url     = process.env.VUE_APP_SERVER_URL + '/notification/save'
            const mandant = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
            const params  = {
              cardcode:                      this.customer.cardcode,
              mandant:                       mandant,
              biotechUser_id:                this.$store.getters.user.id,
            }

            if (newVal != null) {
              params.disableNeuerBesuchsbericht = this.customer.cardcode == 'ALLE' ? newVal : this.isChecked
            } else if (newValApp != null) {
              params.disableNeuerBesuchsberichtApp = this.customer.cardcode == 'ALLE' ? newValApp : this.isCheckedApp
            }

            const that = this
            axios({
              method: 'GET',
              params: params,
              url: url,
            }).then(function () {

              console.log('Notififation Ausnahme gespeichert.')
              if (that.customer.cardcode == 'ALLE') {

                let title = that.$t('message.customerNotifications_fuer_alle_aktivieren')
                let text = that.$t('message.customerNotifications_fuer_alle_aktivieren_ok')
                if (newVal === false || newValApp === false) {
                  title = that.$t('message.customerNotifications_fuer_alle_deaktivieren')
                  text = that.$t('message.customerNotifications_fuer_alle_deaktivieren_ok')
                }
                that.$bvToast.toast(text, {
                  title: title,
                  variant: 'success',
                  autoHideDelay: 3000,
                })
                if (newVal != null) {
                  that.isChecked    = newVal
                }
                if (newValApp != null) {
                  that.isCheckedApp = newValApp
                }

              }
              that.hideSpinner()

            }).catch(error => {
              console.log(error)
              that.$bvToast.toast(that.$t('message.customerNotifications_fuer_alle_deaktivieren_fail'), {
                title: 'Error',
                variant: 'success',
                autoHideDelay: 5000
              })
              that.hideSpinner()
            })

        },
        init: function () {

          if (this.customer) {

            const url     = process.env.VUE_APP_SERVER_URL + '/notification/show'
            const mandant = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
            const params  = {
              cardcode:         this.customer.cardcode,
              mandant:          mandant,
              biotechUser_id:   this.$store.getters.user.id,
            }

            const that = this
            axios({
              method: 'GET',
              params: params,
              url: url,
            }).then(function (response) {

                if (response.data && !response.data['not-available']) {
                  console.log('disableNeuerBesuchsbericht = ' + response.data.disableNeuerBesuchsbericht)
                  that.isChecked    = response.data.disableNeuerBesuchsbericht
                  that.isCheckedApp = response.data.disableNeuerBesuchsberichtApp
                } else if (that.customer.cardcode != 'ALLE') {
                  console.log('keine Antwort, isChecked = true da default true')
                  that.isChecked    = true
                  that.isCheckedApp = true
                }

                // bei Besuchsbericht muss ich das umkehren, da es ja eine Deaktivierung ist
                if (that.isChecked != null) {
                  that.isChecked = !that.isChecked
                }
                if (that.isCheckedApp != null) {
                  that.isCheckedApp = !that.isCheckedApp
                }

            }).catch(error => {
              console.log(error)
            })

          }

        }

      }

    }

</script>